import update from "immutability-helper";
import {RegistrationActions} from "../actions/Registration";

export const initialState = () => {
  return {
    errors: null,
    loaded: false,
    id: null,
    inProgress: false,
    data: null,
  }
}

const reg = (state = initialState(), action) => {
  switch (action.type) {
    case RegistrationActions.SET_ATTRIBUTE:
      return update(state, { [action.key]: { $set: action.value } });
    case RegistrationActions.RESET_STATE:
      return update(state, {$set: initialState})
    default:
      return state;
  }
};

export default reg;
